<template>
  <BookDirectTerms v-if="$siteConfig.brand ==='BookDirect'"/>
  <TermsAndConditions v-else/>
</template>

<script setup lang="ts">
import TermsAndConditions from '@/components/Documents/TermsAndConditions.vue'
import BookDirectTerms from "~/components/Documents/BookDirectTerms.vue";
const { $siteConfig } = useNuxtApp()
const runtimeConfig = useRuntimeConfig()
const brand = $siteConfig?.value?.brand || 'Tripening'

useHead({
  title: `Terms and Conditions | ${brand}`,
  link: [{ rel: 'canonical', href: `${runtimeConfig.public.baseURL}/terms-and-conditions` }],
  meta: [
    { name: 'description', content: `Read the terms and conditions for ${brand}. Understand the rules and guidelines governing the use of our services.` },
  ]
})
</script>

<style scoped lang="scss"></style>
